import Vue from "vue";

Vue.directive("lazy-load", {
  bind(el: HTMLImageElement, binding: any) {
    const imageSrc = binding.value; // URL da imagem real

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.src = imageSrc; // Carrega a imagem real
            observer.unobserve(el); // Para de observar após carregar
          }
        });
      },
      {
        rootMargin: "300px", // Começa a carregar antes da imagem entrar na tela
        threshold: 0.01, // 1% visível da imagem já dispara o carregamento
      }
    );

    el.src = "https://posto-xapa.s3.amazonaws.com/4878A6DD-1E79-";
    observer.observe(el);
  },
});
